import dayjs, { Dayjs } from 'dayjs'
import 'dayjs/plugin/isoWeek'
import isoWeek from 'dayjs/plugin/isoWeek'
import { FloatButton } from 'antd'
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import TodayOutlinedIcon from '@mui/icons-material/TodayOutlined';
import { Dispatch, SetStateAction, useState } from 'react';
import { isMobile } from 'react-device-detect';

dayjs.extend(isoWeek) 
export const MealDateWeekSelectionComponent : React.FC<{
    pickedDate :Dayjs, 
    setPickedDate : Dispatch<SetStateAction<Dayjs>>
}> = (props) => {

    const {pickedDate, setPickedDate} = props
    const [baseDate] = useState<Dayjs>(pickedDate)

    const handleClick = (action : string) => {
        let addSubstractNumber : number
        switch(action) {
            case "add": 
                if (pickedDate.get('date') === 1 && pickedDate.month() === baseDate.month() && pickedDate.isoWeekday() !== baseDate.isoWeekday()) {
                    addSubstractNumber = baseDate.isoWeekday()
                } else if (pickedDate.get('date') > baseDate.daysInMonth() -7) {
                    addSubstractNumber = pickedDate.daysInMonth() - pickedDate.get('date')
                } else {
                    addSubstractNumber = 7
                }
                setPickedDate(pickedDate.add(addSubstractNumber, 'day'));
                break
            case "substract":
                if (pickedDate.get('date') <= 7) {
                    addSubstractNumber = -(pickedDate.get('date')-1)
                } else if (pickedDate.get('date') === pickedDate.daysInMonth() && pickedDate.month() === baseDate.month() && pickedDate.isoWeekday() !== baseDate.isoWeekday()) {
                    addSubstractNumber = pickedDate.isoWeekday() - baseDate.isoWeekday() > 0 ? -(pickedDate.isoWeekday() - baseDate.isoWeekday()) : -(pickedDate.isoWeekday() - baseDate.isoWeekday() + 7)
                    
                } else {
                    addSubstractNumber = -7
                }
                setPickedDate(pickedDate.add(addSubstractNumber, 'day'));
                break
            default: 
                setPickedDate(dayjs())
        }
    }

    return(
        <>
        {isMobile ?
        <>
        {pickedDate.endOf('week').add(1,'day').month() === pickedDate.endOf('month').month() ? <FloatButton onClick={() => {handleClick("add")}} icon={<ArrowForwardIosOutlinedIcon fontSize='small'/>} style={{ insetInlineEnd: 30, width: 45, height: 45}} /> : <></>}
        {pickedDate.month()+1 === dayjs().month()+1  ? <FloatButton onClick={() => handleClick("today")} icon={<TodayOutlinedIcon fontSize='small'/>} style={{ insetInlineEnd: pickedDate.day() <= pickedDate.daysInMonth()-6 ? 85 : 30, width: 45, height: 45 }} /> : <></>}
        {pickedDate.startOf('week').add(-1,'day').month() === pickedDate.startOf('month').month()? <FloatButton onClick={() => handleClick("substract")} icon={<ArrowBackIosNewOutlinedIcon fontSize='small'/>} style={{ insetInlineEnd: 140 - (pickedDate.day() <= pickedDate.daysInMonth()-6 ? 0 : 100) - (pickedDate.month()+1 === dayjs().month()+1 ? 0 : 55), width: 45, height: 45 }} /> : <></>}    
        </>
        :
        <>
        {pickedDate.endOf('week').add(1,'day').month() === pickedDate.endOf('month').month() ? <FloatButton onClick={() => {handleClick("add")}} icon={<ArrowForwardIosOutlinedIcon fontSize='large'/>} description={"Następny tydzień"} style={{ insetInlineEnd: 30, width: 80, height: 80}} /> : <></>}
        {pickedDate.month()+1 === dayjs().month()+1  ? <FloatButton onClick={() => handleClick("today")} icon={<TodayOutlinedIcon fontSize='large'/>} description={"Obecny tydzień"} style={{ insetInlineEnd: pickedDate.day() <= pickedDate.daysInMonth()-6 ? 130 : 30, width: 80, height: 80 }} /> : <></>}
        {pickedDate.startOf('week').add(-1,'day').month() === pickedDate.startOf('month').month()? <FloatButton onClick={() => handleClick("substract")} icon={<ArrowBackIosNewOutlinedIcon fontSize='large'/>} description={"Poprzedni tydzień"} style={{ insetInlineEnd: 230 - (pickedDate.day() <= pickedDate.daysInMonth()-6 ? 0 : 100) - (pickedDate.month()+1 === dayjs().month()+1 ? 0 : 100), width: 80, height: 80 }} /> : <></>}
    </>
        }
        </>
    
    )
}